import { Component, OnInit, ElementRef } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";
import * as Moment from "../../../../node_modules/moment/moment.js"

import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';

@Component({
  selector: 'app-events-preview',
  templateUrl: './events-preview.component.html',
  styleUrls: ['./events-preview.component.css']
})
export class EventsPreviewComponent implements OnInit {

  AllEventsOnAccount:allEventsOnAccount[];
  DatesToBeShown ;
  EventsToBeShown;

  DefaultEventLogo;
  
  AccountData;

  constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) { }

  sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}



  ngOnInit() {
    let account_id = this.route.snapshot.paramMap.get('id');

    //get account data
    this.getdataService.getAccountNameById(account_id).subscribe((accountData) => {
      //console.log(accountData)
      this.AccountData = accountData[0];

    },
    err=>{
      //////console.log(err);
      return false;
    });



    this.getdataService.getEventsByAccountID(account_id).subscribe((allEventsOnAccount) => {
    //console.log(allEventsOnAccount);
    allEventsOnAccount = this.sortByKey(allEventsOnAccount,'event_start_time');
 
      for(let i=0; i<allEventsOnAccount.length ; i++)
      {
        let d = new Date();
        let currentDate = d.getTime();
        let endDate = new Date(allEventsOnAccount[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);

        //console.log("current: ",currentDate,"endDate: ",endDate);
        if(currentDate > endDate){
          //console.log("removing")
          allEventsOnAccount.splice(i,1);
          i--;
        }
      }
      //console.log("array after splicing", allEventsOnAccount);

      // this.getdataService.getMeetingRoombyID(allEventsOnAccount.event_room_id).subscribe((room_data) => {
        this.DefaultEventLogo = "default-thumb.png";
        for(let i=0; i<allEventsOnAccount.length ; i++)
        { 
          if(allEventsOnAccount[i].using_default_logo == "true"){
            
            allEventsOnAccount[i].event_logo_path = this.DefaultEventLogo;
            //console.log( allEventsOnAccount[i].event_logo_path)
          }

        }
      // },
      // err=>{
      //   //////console.log(err);
      //   return false;
      // });
      
      this.AllEventsOnAccount = allEventsOnAccount;

      this.DatesToBeShown = [];
      this.EventsToBeShown = [];
    
      
      for(let i=0; i<this.AllEventsOnAccount.length; i++)
      {
        let timevalue = this.AllEventsOnAccount[i].event_start_time.valueOf();
        var d = new Date(timevalue);
        var currentDate_start = d.setHours(0);
        var currentDate_start = d.setMinutes(0);
        var currentDate_start = d.setSeconds(0);
        //console.log(currentDate_start);
        this.AllEventsOnAccount[i].event_start_time_readable = currentDate_start.toString();

      }

      var hi=0;
      var de=0;
      var lo=0;
      while(hi<this.AllEventsOnAccount.length)
      {
        if(hi>0){
          var eventtimegrabbed = this.AllEventsOnAccount[hi].event_start_time_readable;
          var eventtimegrabbedbeforeit = this.AllEventsOnAccount[hi-1].event_start_time_readable;
          if( eventtimegrabbed  != eventtimegrabbedbeforeit )
          {

            this.DatesToBeShown.push({events:this.AllEventsOnAccount[hi].event_start_time,index:de});
            lo++;
            
          }else{
            de--;
          }
        }else{
          this.DatesToBeShown.push({events:this.AllEventsOnAccount[hi].event_start_time,index:de});
        }
        //console.log(this.AllEventsOnAccount[hi].event_start_time)
        this.EventsToBeShown.push({events:this.AllEventsOnAccount[hi],index:lo})
        de++;
        hi++;
      }

    },
    err=>{
      //////console.log(err);
      return false;
    });
  }

}

//why did I do this? actually when I implement date rounding, it destroys the whole thing so I will use readable part to be the reference
interface allEventsOnAccount{
  _id:number,
  event_name:string,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  using_default_logo:string,
  event_host_name:string
}



// WEBPACK FOOTER //
// ./src/app/components/events-preview/events-preview.component.ts